import { last30DaysTimeRange } from 'src/utils/timeRangeHelpers';

export const formatNumberWithCommas = (numberToFormat: number) => {
  return new Intl.NumberFormat(undefined, { style: 'decimal' }).format(
    numberToFormat,
  );
};

// Pickers need UTC calendar dates in local fields to match UTC query boundaries.
const toPickerDate = (seconds: number): Date => {
  const utc = new Date(seconds * 1000);
  return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
};

export const getTimeRangeFromQueryParams = ({
  from,
  to,
}: {
  from: string | null;
  to: string | null;
}) => {
  if (!from || !to) {
    return last30DaysTimeRange;
  }

  const start = parseInt(from, 10);
  const end = parseInt(to, 10);

  if (!start && !end) {
    return { from: undefined, to: undefined };
  }

  return {
    from: toPickerDate(start),
    to: toPickerDate(end),
  };
};
